import React, { useEffect, useLayoutEffect, useState } from "react";
import debounce from "lodash/debounce";

export function useSidebarHeight(menuOpen: boolean) {
  const [navHeight, setNavHeight] = useState<number | string>("auto");
  useLayoutEffect(() => {
    setNavHeight(
      document.getElementById("accountSidebar")?.clientHeight ?? "auto",
    );

    const handleResize = debounce(() => {
      const height = document.getElementById("accountSidebar")?.clientHeight;
      if (height !== navHeight) {
        setNavHeight(height ?? "auto");
      }
    }, 300);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [navHeight, menuOpen]);

  return navHeight;
}

export const showLinks = ({ focusLink }: { focusLink: boolean }) => {
  const menuLinks: NodeListOf<HTMLAnchorElement> | null =
    document?.querySelectorAll("#accountSidebar a");
  menuLinks.forEach((link) => link.setAttribute("tabindex", "0"));
  if (!focusLink) return;
  // Rapid reorder link is hidden on smaller screen sizes
  if (menuLinks[0]?.innerText.includes("Rapid Reorder")) {
    menuLinks[1]?.focus();
    return;
  }
  menuLinks[0]?.focus();
};

export const hideLinks = ({ focusMenu }: { focusMenu: boolean }) => {
  const menuLinks: NodeListOf<HTMLAnchorElement> | null =
    document?.querySelectorAll("#accountSidebar a");
  menuLinks.forEach((link) => link.setAttribute("tabindex", "-1"));
  if (!focusMenu) return;
  const menuButton: HTMLButtonElement | null =
    document?.querySelector("#toggle-menu");
  menuButton?.focus();
};

export function useDebouncedResize() {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = debounce(() => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    }, 300);
    window.addEventListener("resize", handleResize);
    return () => {
      handleResize.cancel();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return size;
}
